import React, { useState, useEffect, useRef, useMemo } from "react";
import Card from "react-bootstrap/Card";

import PropTypes from "prop-types";
import { useUserMedia } from "../../../custom-hooks/useUserMedia";
import CountdownBox from "../countdownBox/countdownBox";
import PopConfirmSnapshot from "../popConfirmSnapshot/popConfirmSnapshot";
import { useSelector, useDispatch } from "react-redux";
import { setCam1Start } from "../../../redux/features/timer/timerSlice";
import "./videoCard.scss";
import { VIDEO_SIZE } from "../../../utils/utils";
import { isMobile } from "@tensorflow/tfjs-core/dist/device_util";

const VideoCard = () => {
  const videoEl = useRef();
  const dispatch = useDispatch();
  const showCount = useSelector((state) => state.snapshot.showCount);
  const userData = useSelector((state) => state.auth.userData);
  const onTakeshot = useRef(false);
  const [number, setNumber] = useState(4);
  const [intervalValue, setIntervalValue] = useState();
  const requestedMedia = useMemo(
    () => ({
      audio: false,
      video: {
        facingMode: "user",
        width: isMobile()
          ? VIDEO_SIZE["360 X 270"].width
          : VIDEO_SIZE["480 X 360"].width,
        height: isMobile()
          ? VIDEO_SIZE["360 X 270"].height
          : VIDEO_SIZE["480 X 360"].height,

        // resizeMode: "crop-and-scale"
      },
    }),
    []
  );
  const mediaStream = useUserMedia(requestedMedia);

  /*
  useEffects hooks for initiators and preventive rerenders
  **/
  useEffect(() => {
    videoEl.current.srcObject = mediaStream;

    return () => {};
  }, [mediaStream]);

  useEffect(() => {
    if (onTakeshot.current) {
      let interval = setInterval(() => {
        setNumber((num) => num - 1);
      }, 1000);
      console.log("take snapshot");
      setIntervalValue(interval);
    } else {
      onTakeshot.current = true;
    }
  }, [showCount]);

  useEffect(() => {
    console.log(number);
    if (number <= 0) {
      clearInterval(intervalValue);
      setNumber(4);
    }
  }, [number, intervalValue]);

  function handleCanPlay() {
    videoEl.current.play();
    //dispatch canplay on cam1
    dispatch(setCam1Start(true));
  }
  return (
    <div className="position-relative">
      <Card className="video-card">
        <div className="position-relative">
          <video
            width={180}
            className="video"
            ref={videoEl}
            onCanPlay={handleCanPlay}
            autoPlay
            muted
            playsInline
            style={{
              transform: "scaleX(-1)",
              // visibility:"hidden",
            }}
          ></video>
          {
            <>
              {number === 3 && (
                <CountdownBox
                  className="position-absolute top-50 start-50 translate-middle"
                  count={number - 1}
                />
              )}
              {number === 2 && (
                <CountdownBox
                  className="position-absolute top-50 start-50 translate-middle"
                  count={number - 1}
                />
              )}
            </>
          }
        </div>

        <Card.Body className="p-2">
          <p className="text-primary fw-bold mb-1">{userData.firstName}</p>
          <p style={{ fontSize: 12 }} className="text-success mb-1">
            Exam Ongoing...
          </p>
        </Card.Body>
      </Card>
      {number === 1 && (
        <PopConfirmSnapshot
          className="position-absolute top-50 start-100 translate-overides"
          count={number - 1}
        />
      )}
    </div>
  );
};

VideoCard.propTypes = {
  message: PropTypes.string,
};

export default VideoCard;
